import React from 'react';
import { RevealSection, RevealCard } from '../Animations';

const Process = () => {
  const steps = [
    {
      number: '01',
      title: 'Free AI Audit',
      description:
        'We analyze your current business processes to identify the highest ROI opportunities for AI automation and workflow optimization.',
    },
    {
      number: '02',
      title: 'Custom Build',
      description:
        "Our expert developers build a custom AI solution, whether it's a voice agent or an n8n workflow, tailored to your specific needs.",
    },
    {
      number: '03',
      title: 'Fast Launch',
      description:
        'We integrate the new AI tools into your existing tech stack with zero disruption, ensuring your team is trained and ready to go.',
    },
    {
      number: '04',
      title: 'Ongoing Support',
      description:
        'We provide 24/7 monitoring and continuous improvements to ensure your AI systems scale perfectly as your business grows.',
    },
  ];

  return (
    <section id="process" className="section-padding relative">
      <div className="container-custom">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12 md:mb-16">
          <RevealSection className="lg:col-span-7">
            <span className="eyebrow">02. Process</span>
            <div className="mt-3 mb-8 h-px bg-white/10" />
            <h2 className="text-[clamp(2rem,4.5vw,3.5rem)] font-display font-semibold text-white leading-[1.05] tracking-[-0.03em]">
              From idea to results
            </h2>
          </RevealSection>
          <RevealSection className="lg:col-span-5">
            <p className="text-[17px] text-zinc-400 leading-[1.65] max-w-xl">
              We make implementing AI simple. No technical headaches, no complicated jargon, just results that help your business scale.
            </p>
          </RevealSection>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/10 rounded-[var(--radius-lg)] overflow-hidden">
          {steps.map((s) => (
            <RevealCard
              key={s.number}
              className="relative p-8 bg-[color:var(--color-bg-base)] group"
            >
              <div className="flex items-center justify-between mb-8">
                <span
                  data-mono
                  className="text-[11px] uppercase tracking-[0.12em] text-zinc-500"
                >
                  Step {s.number}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--color-accent)]" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-3 tracking-[-0.01em]">
                {s.title}
              </h3>
              <p className="text-sm text-zinc-400 leading-relaxed">
                {s.description}
              </p>
            </RevealCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
